// AdminMaterialRows.tsx — (B112; Creative 2's C2.5-4 step 0 §2.4) the operator's view in the Run Inspector: the run's
// material rows (every hop of a decision material at any hop; the customer's list keeps the ones still changed), each with its step, outcome, reason and span —
// GET /api/admin/runs/:runId/material-rows (the workers' ?material=1). Operator text: not the customer's words.
import { useEffect, useState } from "react";
import { apiGet } from "@/api/client.ts";

export interface MaterialRowView { decisionId: string; kind: string; beatId: string | null; outcome: string; reason: string | null; detail: string | null;
  stepId: string; spanId: string | null; at: string }

export function AdminMaterialRows({ runId }: { runId: string }) {
  const [rows, setRows] = useState<MaterialRowView[] | null>(null);
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;   // an answer that lands after a newer run's is dropped
    setRows(null); setErr(null);
    apiGet<{ rows: MaterialRowView[] }>(`/admin/runs/${runId}/material-rows`).then((r) => { if (alive) setRows(r.rows); })
      .catch((e) => { if (alive) setErr(String((e as Error)?.message ?? e)); });   // catch-reason: shown in place of the rows
    return () => { alive = false; };
  }, [runId]);
  if (err) return <div style={{ color: "#b91c1c", fontSize: 13 }}>The material rows couldn't be read: {err}</div>;
  if (!rows) return null;
  return (
    <details style={{ margin: "8px 0", fontSize: 13 }}>
      {/* (audit 10-25) every hop of each decision that was material at any hop: one put right later is here too, while the
          customer's list (the final review) leaves it out */}
      <summary>Material rows, every hop ({rows.length}) — the customer's list keeps only those still changed</summary>
      {rows.length === 0 ? <div className="tf-muted">None recorded for this run.</div> : (
        <table style={{ borderCollapse: "collapse", marginTop: 6 }}>
          <thead><tr>{["step", "decision", "beat", "outcome", "reason", "detail", "span", "at"].map((h) => <th key={h} style={{ textAlign: "left", padding: "2px 8px" }}>{h}</th>)}</tr></thead>
          <tbody>{rows.map((r, i) => (
            <tr key={`${r.decisionId}-${i}`}>
              <td style={{ padding: "2px 8px" }}>{r.stepId}</td><td style={{ padding: "2px 8px" }}>{r.decisionId}</td>
              <td style={{ padding: "2px 8px" }}>{r.beatId ?? "the video"}</td><td style={{ padding: "2px 8px" }}>{r.outcome}</td>
              <td style={{ padding: "2px 8px" }}>{r.reason ?? "—"}</td><td style={{ padding: "2px 8px" }}>{r.detail ?? "—"}</td>
              <td style={{ padding: "2px 8px" }}><code>{r.spanId ?? "—"}</code></td><td style={{ padding: "2px 8px" }}>{new Date(r.at).toLocaleString()}</td>
            </tr>))}</tbody>
        </table>
      )}
    </details>
  );
}
